module.exports = __webpack_public_path__ + "img/Snorres-kongesoger_Maleri-pa-bunnen-av-siden.81c51df9.jpg";